import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class StdStandardService {
  // 综合统计
  static async getStatisticsTop(standardId) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DataValidationReport/get-statistics-top/${standardId}`)
    )
    return Callback(err, res)
  }
  // 综合统计表格数据
  static async getStatisticsList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/DataValidationReport/get-statistics-list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 导出综合统计表格数据
  static async getStatisticsExport(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/DataValidationReport/get-statistics-export?${qs.stringify(payload)}`,
        { responseType: 'blob' }
      )
    )
    return Callback(err, res)
  }
  // 对象/文档合规性校验报表导出
  static async getDataValidationComplianceExport(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/DataValidationReport/get-data-validation-compliance-export?${qs.stringify(
          payload
        )}`,
        { responseType: 'blob' }
      )
    )
    return Callback(err, res)
  }
  // 对象属性完整性报表导出
  static async getTagAttributeIntegrityExport(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/DataValidationReport/get-tag-attribute-integrity-export?${qs.stringify(payload)}`,
        { responseType: 'blob' }
      )
    )
    return Callback(err, res)
  }
  // 对象属性完整性报表
  static async getTagAttributeIntegrityList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/DataValidationReport/get-tag-attribute-integrity-list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 空文档目录校验报表导出
  static async getEmptyDocumentCategoryExport(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/document/folder-report-export',
          payload,
        { responseType: 'blob' }
      )
    )
    return Callback(err, res)
  }
  // 文档文件完整性校验报表导出
  static async getDocumentFileReportExport(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/document/document-file-report-export',
          payload,
        { responseType: 'blob' }
      )
    )
    return Callback(err, res)
  }
  // 空文档目录校验报表
  static async getEmptyCategoryReport(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/document/folder-report?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 文档文件完整性校验报表
  static async getDocumentFileReport(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/document/document-file-report?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 对象/文档合规性校验报表
  static async getDataValidationComplianceList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/DataValidationReport/get-data-validation-compliance-list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 规则设置保存【正则表达式】
  static async validationRuleSave(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataValidationRuleRegularExpression/many-save', payload)
    )
    return Callback(err, res)
  }
  // 规则设置批量删除【正则表达式】
  static async validationRuleDelete(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/DataValidationRuleRegularExpression/many', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 规则设置获取详情【正则表达式】
  static async getValidationRuleDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/DataValidationRuleRegularExpression?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 规则设置保存【符号分割】
  static async charSplitRuleSave(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataValidationRuleCharSplit/many-save', payload)
    )
    return Callback(err, res)
  }
  // 获取分段规则类型【符号分割】
  static async charSplitGetSectionRule() {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataValidationRuleCharSplit/get-section-rule')
    )
    return Callback(err, res)
  }
  // 规则设置批量删除【符号分割】
  static async charSplitRuleDelete(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/DataValidationRuleCharSplit/many', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 规则设置获取详情【符号分割】
  static async getCharSplitRuleDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DataValidationRuleCharSplit?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
